import { Merchant } from "@src/app/authStore"

export const enum ONBOARDING_TOURS {
  WELCOME,
  MANDATORY_INITIAL_SETUP,
  API_INTEGRATION,
  ACCOUNT_TOP_UP,
  MASS_CRYPTO,
  EXCHANGE,
  CRYPTO_PAYMENTS,
  SENDING_INVOICES,
  TRANSACTION_HISTORY_AND_REPORTS,
  ON_RAMP_WIDGET,
}

export const enum TOUR_STEP_STATUSES {
  INIT,
  IN_PROGRESS,
  CLOSED,
  COMPLETED,
}

export const enum TOUR_MODAL_PLACEMENTS {
  BOTTOM,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
  CENTER,
  LEFT,
  RIGHT,
  TOP,
  TOP_LEFT,
  TOP_RIGHT,
}

export type PlacementType = {
  bottom?: number
  left?: number
  right?: number
  top?: number
}
export type PlacementsType = Record<TOUR_MODAL_PLACEMENTS, PlacementType>

export type TourContext = {
  merch: Merchant | undefined
}

export type OnboardingCashedState = {
  completed: ONBOARDING_TOURS[]
  isClosed: boolean
  settings: ONBOARDING_TOURS[]
  step?: string
  tourInProgress?: ONBOARDING_TOURS
}
